import React from "react";
import * as PropTypes from "prop-types";
import PlanChoice from "./PlanChoice";

const PlanChoices = (props) => {
  return (
    <div className="row mx-auto">
      {
        props.plans.map(plan =>
          <PlanChoice
            key={plan.id}
            plan={plan}
            onSelected={plan => props.onPlanSelected(plan)}
            isClicked={props.selectedPlan ? props.selectedPlan.id === plan.id : false}
          />
        )
      }
    </div>
  );
};

PlanChoices.propTypes = {
  plans: PropTypes.array.isRequired,
  onPlanSelected: PropTypes.func.isRequired,
  selectedPlan: PropTypes.object
};

export default PlanChoices;